import { Provider } from '@angular/core';
import { AccessModel } from 'models/access.model';
import { AdminModel } from 'models/admin.model';
import { ApiModel } from 'models/api.model';
import { BlockedProductsModel } from 'models/blocked-products.model';
import { BrandModel } from 'models/brand';
import { FileModel } from 'models/file.model';
import { ImageModel } from 'models/image.model';
import { NewsModel } from 'models/news.model';
import { OrderRightsModel } from 'models/order-rights.model';
import { OrganizationModel } from 'models/organization.model';
import { ProductModel } from 'app/content/models/product.model';
import { S3FileModel } from 'models/s3File.model';
import { UpdatesModel } from 'models/updates.model';
import { UploadAuthorizationModel } from 'models/upload-authorization.model';
import { UserModel } from 'models/user.model';
import { ReferralModel } from 'models/referral.model';
import { OrdersModel } from 'shared/models';
import { LandingPageModel } from 'app/b2b-order/models/landing-page.model';
import { DownloadModel } from 'app/content/models/download.model';
import { CrmServiceModel } from 'shared/models/crm-service.model';
import { AdminV2Model } from 'shared/models/admin-v2.model';

export const modelProviders = [
    ApiModel,
    CrmServiceModel,
    AdminV2Model,
    S3FileModel,
    AccessModel,
    OrderRightsModel,
    OrganizationModel,
    BrandModel,
    BlockedProductsModel,
    ProductModel,
    ImageModel,
    NewsModel,
    FileModel,
    DownloadModel,
    UploadAuthorizationModel,
    AdminModel,
    UserModel,
    UpdatesModel,
    ReferralModel,
    OrdersModel,
    LandingPageModel
] as Provider[];
